/**
 * Shared problem-details helpers for the knowledge screens (spec 20 §5): every
 * failure response is `application/problem+json` with a `type` ending in the
 * problem slug, e.g. `.../problems/property-name-taken`.
 */
const PROBLEM_SLUG = /\/problems\/([a-z-]+)$/;

export interface Problem {
  readonly type?: string;
  readonly errors?: ReadonlyArray<{ field: string; code: string }>;
}

export function problemSlug(problem: Problem | undefined): string | undefined {
  return problem?.type?.match(PROBLEM_SLUG)?.[1];
}

export function fieldErrors(problem: Problem | undefined): Record<string, string> {
  return Object.fromEntries((problem?.errors ?? []).map((error) => [error.field, error.code]));
}
